export default __webpack_public_path__ + "static/media/dark2.fb9da9e3.svg";